import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
/** Returns true when a MIME type should be rendered as plain text/markup. */
export function isTextContentType(contentType) {
  return contentType === "text/html" || contentType === "text/xml" || contentType === "application/xml" || contentType.startsWith("text/");
}

/** Fetches document content from a pre-signed URL as text or an object URL. */
export function fetchDocumentFromUrl(_x, _x2) {
  return _fetchDocumentFromUrl.apply(this, arguments);
}

/** Returns copy-ready plain text, stripping markup for HTML content. */
function _fetchDocumentFromUrl() {
  _fetchDocumentFromUrl = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(url, contentType) {
    var response, arrayBuffer, blob, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (url) {
            _context.n = 1;
            break;
          }
          throw new Error("Document URL is missing");
        case 1:
          _context.n = 2;
          return fetch(url);
        case 2:
          response = _context.v;
          if (response.ok) {
            _context.n = 3;
            break;
          }
          throw new Error("Failed to fetch document content: ".concat(response.status, " ").concat(response.statusText));
        case 3:
          if (!isTextContentType(contentType)) {
            _context.n = 5;
            break;
          }
          _context.n = 4;
          return response.text();
        case 4:
          _t = _context.v;
          return _context.a(2, {
            htmlContent: _t,
            blobUrl: ""
          });
        case 5:
          _context.n = 6;
          return response.arrayBuffer();
        case 6:
          arrayBuffer = _context.v;
          blob = new Blob([arrayBuffer], {
            type: contentType
          });
          return _context.a(2, {
            blobUrl: URL.createObjectURL(blob)
          });
      }
    }, _callee);
  }));
  return _fetchDocumentFromUrl.apply(this, arguments);
}
export function extractPlainText(content, contentType) {
  if (contentType !== "text/html") return content;
  if (typeof document === "undefined") return content;
  var container = document.createElement("div");
  container.innerHTML = content;
  return container.textContent || container.innerText || "";
}

/** Strips a Python byte-string wrapper and non-base64 characters from raw data. */
function sanitizeBase64(raw) {
  var data = raw;
  if (data.startsWith("b'") && data.endsWith("'")) {
    data = data.substring(2, data.length - 1);
  } else if (data.startsWith('b"') && data.endsWith('"')) {
    data = data.substring(2, data.length - 1);
  }
  return data.replace(/\s/g, "").replace(/[^A-Za-z0-9+/=]/g, "");
}

/** Decodes inline base64 content into text or an object URL. */
export function decodeBase64Content(raw, contentType) {
  var data = sanitizeBase64(raw);
  if (!data) throw new Error("Base64 data is empty");
  if (isTextContentType(contentType)) {
    return {
      htmlContent: atob(data),
      blobUrl: ""
    };
  }
  if (!/^[A-Za-z0-9+/]*={0,2}$/.test(data)) throw new Error("Invalid base64 format");
  var byteCharacters = atob(data);
  var byteNumbers = new Uint8Array(byteCharacters.length);
  for (var i = 0; i < byteCharacters.length; i += 1) {
    byteNumbers[i] = byteCharacters.charCodeAt(i) & 0xff;
  }
  var blob = new Blob([byteNumbers], {
    type: contentType
  });
  return {
    blobUrl: URL.createObjectURL(blob)
  };
}